// extracted by mini-css-extract-plugin
module.exports = {"mobileHidden":"MobileSearchInput_mobileHidden__byIOx","hasResults":"MobileSearchInput_hasResults__3Vhty","dropdownClosed":"MobileSearchInput_dropdownClosed__9KqBQ"};